import { forwardRef } from 'react';
import { Icon } from './icon';
import type { IconProps } from './icon';
import type { Ref } from 'react';
export const Clock = forwardRef(function Clock(props: IconProps, ref: Ref<SVGSVGElement>) {
  return (
    <Icon {...props} ref={ref}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.53 1.47a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 0 1-1.06-1.06l3-3a.75.75 0 0 1 1.06 0ZM3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0ZM12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 8a.75.75 0 0 0-1.5 0v4c0 .25.125.485.334.624l3 2a.75.75 0 1 0 .832-1.248l-2.666-1.777V8Zm5.72-5.47a.75.75 0 1 1 1.06-1.06l3 3a.75.75 0 1 1-1.06 1.06l-3-3Z"
        fill="currentColor"
      />
    </Icon>
  );
});
